import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'

import { AccountInfoComponent } from '@se-po/se-household-setup-feature-account-info'
import { CreatePasswordComponent } from '@se-po/se-household-setup-feature-create-password'
import { MatchComponent } from '@se-po/se-household-setup-feature-match'
import { VerificationComponent } from '@se-po/se-household-setup-feature-verification'

import { CreateAccountComponent } from './create-account.component'

const routes: Routes = [
  {
    path: '',
    component: CreateAccountComponent,
    children: [
      {
        path: '',
        component: AccountInfoComponent,
      },
      {
        path: 'create-password',
        component: CreatePasswordComponent,
      },
      {
        path: 'match',
        component: MatchComponent,
      },
      {
        path: 'verification',
        component: VerificationComponent,
      },
    ]
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ]
})
export class CreateAccountRoutingModule { }
